import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DatePickerUtils } from '../mp-date-picker/mp-date-picker.utils';

@Component({
  selector: 'app-mp-hour-picker',
  templateUrl: './mp-hour-picker.component.html',
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule
  ],
  styleUrl: './mp-hour-picker.component.scss'
})
export class MpHourPickerComponent implements OnDestroy, OnChanges {
  @Input() public label: string;
  @Input() public disabled: boolean;
  @Input() public inputValue: string;
  @Input() public formControlField: FormControl;

  /** 'small' | 'medium' | 'large' */
  @Input() public size: 'small' | 'medium' | 'large' = 'large';
  @Input() public customClasses: string = '';

  @Output() inputValueChange = new EventEmitter<string>();

  public hourValue: string;

  public isInvalid: boolean = false;
  private hours: string;

  private minutes: string;
  private valueChangeTimer: ReturnType<typeof setTimeout>;
  private blurTimer: ReturnType<typeof setTimeout>;
  private formControlSub: Subscription;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['inputValue'] || changes['formControlField']) {
      if (this.formControlField) {
        this.setHourPickerValue(this.formControlField.value);
      } else {
        this.setHourPickerValue(this.inputValue);
      }
    }
  }

  ngOnDestroy() {
    if (this.formControlSub) {
      this.formControlSub.unsubscribe();
    }
  }

  public onValueChanged() {
    if (this.valueChangeTimer) {
      clearTimeout(this.valueChangeTimer);
    }

    if (!this.disabled) {
      this.valueChangeTimer = setTimeout(() => {
        if (!this.isHourValid(this.hourValue)) {
          this.isInvalid = true;
        } else if (!this.formControlField) {
          this.inputValueChange.emit(this.hourValue);
        } else {
          this.formControlField.setValue(this.hourValue);
          this.inputValueChange.emit(this.formControlField.value);
        }
      }, 300);
    }
  }

  public onHourPickerBlur() {
    if (this.blurTimer) {
      clearTimeout(this.blurTimer);
    }
    this.blurTimer = setTimeout(() => {
      this.correctHour();
    }, 0);
  }

  public setHourPickerValue(value: string) {
    if (value) {
      const splitted = value.split(':');
      if (splitted.length === 2) {
        this.hours = DatePickerUtils.addPaddingToDatesFields(splitted[0], 2);
        this.minutes = DatePickerUtils.addPaddingToDatesFields(splitted[1], 2);
        this.hourValue = `${this.hours}:${this.minutes}`;
      }
    } else {
      this.hours = undefined;
      this.minutes = undefined;
      this.hourValue = undefined;
    }
  }

  private correctHour() {
    if (this.hourValue && this.hourValue.length) {
      let splitted: string[] = [];
      if (this.hourValue.includes('.')) {
        splitted = this.hourValue.trim().split('.');
      } else if (this.hourValue.includes('-')) {
        splitted = this.hourValue.trim().split('-');
      } else if (this.hourValue.includes('/')) {
        splitted = this.hourValue.trim().split('/');
      } else {
        splitted = this.hourValue.trim().split(':');
      }

      if (splitted[0]) {
        this.hours = splitted[0];
      } else {
        this.hours = '00';
      }
      if (splitted[1]) {
        this.minutes = splitted[1];
      } else {
        this.minutes = '00';
      }


      if (this.hours && !isNaN(+this.hours) &&
        this.minutes && !isNaN(+this.minutes)) {
        const minutes = this.minutes;
        const hours = this.hours;
        // Not needed for now
        // if (+minutes > 59) {
        //   hours = `${+hours + Math.trunc(+minutes / 60)}`;
        //   minutes = `${+minutes % 60}`;
        // }
        // if (+hours > 23) {
        //   hours = `${+hours % 24}`;
        // }
        this.setHourPickerValue(`${hours}:${minutes}`);
        this.onValueChanged();
      }
    } else {
      this.hours = undefined;
      this.minutes = undefined;
      this.onValueChanged();
    }

  }

  private isHourValid(hourString: string) {
    if (hourString) {
      const splitted = hourString.split(':');
      return splitted[0] && +splitted[0] >= 0 &&
        +splitted[0] <= 24 && splitted[1] &&
        +splitted[1] <= 60 && +splitted[1] >= 0;
    }
    return true;
  }


}
